module.exports = __webpack_public_path__ + "img/wheel.7efd7771.png";